import { useServices } from '@/app/providers';
import { useI18n } from '@/shared/i18n';
import { Eye, LogOut } from 'lucide-react';

export const ImpersonationBanner = () => {
  const { impersonation, exitImpersonation } = useServices();
  const { t } = useI18n();

  if (!impersonation) return null;

  const handleExit = async () => {
    await exitImpersonation();
    // Full reload (not SPA navigate): the in-place currentUser/ability
    // transition back to admin was leaving the page blank, a fresh mount
    // via the normal boot flow always renders correctly.
    window.location.href = '/admin-v2';
  };

  const roleLabel = t(`roles.${impersonation.impersonating.memberRole}`);

  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow-md">
      <Eye size={16} />
      <span>
        {t('impersonation.banner', {
          name: impersonation.impersonating.memberName,
          role: roleLabel,
        })}
      </span>
      <button
        onClick={handleExit}
        className="ml-2 inline-flex items-center gap-1 rounded-md bg-white/20 px-2.5 py-1 font-semibold hover:bg-white/30 transition-colors"
      >
        <LogOut size={14} />
        {t('impersonation.exit')}
      </button>
    </div>
  );
};
